import React, { FC } from 'react'
import UserManagementContainer from 'containers/UserManagement'

const UserManagementPage: FC = () => <UserManagementContainer />

export default UserManagementPage
